import {GetterTree} from 'vuex'
import {StatisticState} from './types';
import {RootState} from '@/store/types';

export const getters: GetterTree<StatisticState, RootState> = {
    statisticsDictGrouping: state => state.statisticsDictGrouping,
    staticGroupIncom: state => state.staticGroupIncom,
    statisticDetailIncoming: state => state.statisticDetailIncoming,
    statisticDetailIncomingFlag: state => state.statisticDetailIncomingFlag,
    statisticGroupIncoming: state => state.statisticGroupIncoming,
    incomingGroupBy: state => state.statisticsDictGrouping.incomingGroupBy,
    incomingGroupByOptionally: state => state.statisticsDictGrouping.incomingGroupByOptionally,
    staticDetailIncom: state => state.staticDetailIncom,
    staticDetailIncomFlag: state => state.staticDetailIncomFlag,
};
